/**
 * @category  Puma
 * @author    Deniss Dubinins <denissd@scandiweb.com | info@scandiweb.com>
 * @copyright Copyright (c) 2022 Scandiweb, Inc (https://scandiweb.com)
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { withRouter } from 'react-router-dom';

import { HistoryType, LocationType } from 'Type/Router.type';
import { setQueryParams } from 'Util/Url';

import SelectedFiltersComponent from './SelectedFilters.component';

/** @namespace Scandipwa/Component/SelectedFilters/Container */
export class SelectedFiltersContainer extends PureComponent {
    static propTypes = {
        selectedFilters: PropTypes.objectOf(PropTypes.shape).isRequired,
        availableFilters: PropTypes.objectOf(PropTypes.shape).isRequired,
        location: LocationType.isRequired,
        history: HistoryType.isRequired
    };

    onResetClick = this.onResetClick.bind(this);

    urlStringToObject = this.urlStringToObject.bind(this);

    resetAttribute(code, optionId) {
        const { customFilters } = this.urlStringToObject();

        return customFilters.split(';').map((customFilter) => {
            if (customFilter.includes(code)) {
                const selectedOptions = customFilter.split(':')[1];

                if (selectedOptions === optionId) {
                    return null;
                }

                const selectedOptionsArray = selectedOptions
                    .split(',')
                    .filter((selectedOptionId) => selectedOptionId !== optionId);

                return `${ code }:${ selectedOptionsArray }`;
            }

            return customFilter;
        }).filter((customFilter) => customFilter).join(';');
    }

    urlStringToObject() {
        const { location: { search = '' } } = this.props;

        return search.substr(1).split('&').reduce((acc, part) => {
            const [key, value] = part.split('=');

            return { ...acc, [key]: value };
        }, {});
    }

    onResetClick(attributeCode, attributeOptionId) {
        const { location, history } = this.props;

        if (attributeCode === 'price') {
            setQueryParams({
                priceMin: '',
                priceMax: '',
                page: ''
            }, location, history);

            return;
        }

        if (attributeCode && attributeOptionId) {
            setQueryParams({
                customFilters: this.resetAttribute(attributeCode, attributeOptionId),
                page: ''
            }, location, history);

            return;
        }

        setQueryParams({
            customFilters: '',
            priceMin: '',
            priceMax: '',
            page: ''
        }, location, history);
    }

    createSearchSelectedFilters(customFilters, priceMax = 0, priceMin = 0) {
        const selectedFilters = {};

        if (!customFilters) {
            if (priceMax && priceMin) {
                return { customFilters: {}, priceRange: { min: priceMin, max: priceMax } };
            }

            return {};
        }

        // eslint-disable-next-line array-callback-return
        customFilters.split(';').map((customFilter) => {
            const selectedOptions = customFilter.split(':')[1].split(',');
            const selectedFilter = customFilter.split(':')[0];
            Object.assign(selectedFilters, { [selectedFilter]: selectedOptions });
        });

        return { customFilters: selectedFilters, priceRange: { min: priceMin, max: priceMax } };
    }

    render() {
        const { availableFilters, selectedFilters } = this.props;
        const { customFilters, priceMax = 0, priceMin = 0 } = this.urlStringToObject();
        // eslint-disable-next-line fp/no-let
        let filters = selectedFilters;

        if (Object.keys(selectedFilters).length === 0) {
            filters = this.createSearchSelectedFilters(customFilters, priceMax, priceMin);
        }

        return (
            <SelectedFiltersComponent
              selectedFilters={ filters }
              availableFilters={ availableFilters }
              onResetClick={ this.onResetClick }
            />
        );
    }
}

export default withRouter(SelectedFiltersContainer);
